import type { DeviceBreakdown } from "@/api";

const ROWS: { key: keyof DeviceBreakdown; label: string }[] = [
  { key: "desktop", label: "Desktop" },
  { key: "mobile", label: "Mobile" },
  { key: "tablet", label: "Tablet" },
  { key: "unknown", label: "Unknown" },
];

export function DevicesCard({ devices }: { devices: DeviceBreakdown }) {
  const total = ROWS.reduce((sum, r) => sum + devices[r.key], 0);
  return (
    <div className="card p-5">
      <div className="label mb-4">Devices</div>
      <ul className="space-y-3">
        {ROWS.map((r) => {
          const count = devices[r.key];
          const pct = total > 0 ? Math.round((count / total) * 100) : 0;
          return (
            <li key={r.key} className="flex items-center gap-3">
              <span className="w-20 text-sm text-dim">{r.label}</span>
              <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-ink-3">
                <span className="block h-full rounded-full bg-lilac" style={{ width: `${pct}%` }} />
              </span>
              <span className="w-16 text-right text-sm tabular-nums text-text">
                {pct}% <span className="text-faint">({count})</span>
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
